import { Box, Typography, List, ListItem } from '@mui/material'

export default function ActionsList({ actions }) {
  return (
    <Box p={3} border={1} borderColor="grey.300" borderRadius={2} mb={1}>
      {actions.length > 0 ? (
        <List>
          {actions.map((req, i) => (
            <ListItem key={i}>
              {req.key} - {req.name} - {req.description}
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body1">No actions specified.</Typography>
      )}
    </Box>
  )
}
